import React, {useState} from "react";

export const TextArea = (props) => {

const toUpperCaseValue = () => {
  let newText = text.toUpperCase();
  setText(newText);
  props.showAlert("success","Changed to UpperCase");
}

const toLowerCaseValue = () => {
  let newText = text.toLowerCase();
  setText(newText);
  props.showAlert("success","Changed to LowerCase");
}

const changeValue = (event)=>{
  setText(event.target.value);
}

const copyText = ()=>{
  /* Get the text field */
  var copyGfGText = document.getElementById("floatingTextarea2");
  
  /* Select the text field */
  copyGfGText.select();
  
  /* Copy the text inside the text field */
  document.execCommand("copy");
  props.showAlert("success","Text copied to clipboard");
}

const clearText = () =>{
  setText('');
  props.showAlert("success","Cleared box");
}

const removeExtraSpaces = () =>{
  let newText = text.split(/[ ]+/);
  setText(newText.join(" "));
  props.showAlert("success","Extra spaces removed");
}

let style = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingEnd : 5,
}


//DRY principal violated here, will come to this after sometime :)
const changeColorG = () =>{
  document.body.style.background = `${props.mode === 'light'?'light':'#0a3d0a'}`;
}
const changeColorB = () =>{
  document.body.style.background = `${props.mode === 'light'?'light':'#411414'}`;
}
const changeColorGr = () =>{
  document.body.style.background = `${props.mode === 'light'?'light':'#474141'}`;
}
const changeColorPi = () =>{
  document.body.style.background = `${props.mode === 'light'?'light':'rgb(67 24 54)'}`;
}
const changeColorPu = () =>{
  document.body.style.background = `${props.mode === 'light'?'light':'#520d52'}`;
}
  const [text, setText] = useState('');
  return (
    <>
          <div className="my-5 toggleMode-1">
        <div className={`form-check form-switch text-${props.mode === 'light'?'black':'white'}`} onClick={props.toggleMode}>
          <input className="form-check-input toggleMode " type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
    </div>
    <div className="more-options d-flex my-3">
            <div className="green mx-1" id="green" onClick={changeColorG}></div>
            <div className="brown mx-1" id="brown" onClick={changeColorB}></div>
            <div className="gray mx-1" id="gray" onClick={changeColorGr}></div>
            <div className="pink mx-1" id="pink" onClick={changeColorPi}></div>
            <div className="purple mx-1" id="purple" onClick={changeColorPu}></div>
          </div>
    </div>
    <div className={`container my-5 text-${props.mode === 'light'?'black':'white'}`}>
        <h1 className="my-3">Write your text below.</h1>
      <div className="form-floating">
        <textarea
          className="form-control" placeholder="Leave a comment here" value={text}  id="floatingTextarea2" style={{height : 200 + 'px'}} onChange={changeValue}
        ></textarea>
      </div>
      <button className="btn btn-primary my-3 mx-1" onClick={toUpperCaseValue}>Change to UPPERCASE</button>
      <button className="btn btn-primary my-3 mx-1" onClick={toLowerCaseValue}>Change to lowercase</button>
      <button className="btn btn-primary my-3 mx-1" id="clipBoard" onClick={copyText}>Copy to Clipboard</button>
      <button className="btn btn-primary my-3 mx-1" id="clearText" onClick={clearText}>Clear text</button>
      <button className="btn btn-primary my-3 mx-1" id="clearText" onClick={removeExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container part-2 d-flex">
      <div className="wordsCount text-center">
        <h2>Number of words : {text.split(" ").length}</h2>
      </div>
      <div className="lettersCount text-center">
        <h2>Number of characters : {text.length}</h2>
      </div>
    </div>
      <div className={"container previewAndReadTime my-5"}>
        <div className={`pund text-center my-3 text-${props.mode === 'light'?'black':'white'}`}>
        <h3 id="previewText">Preview : {Math.ceil(0.008 * text.split(" ").length)} Minutes of read.</h3>
        <div style={style}>
          <div id="underLine"></div>
          </div>
        </div>
        <p className={`text-${props.mode === 'light'?'black':'white'}`}>{text}</p>
      </div>
    </>
  );
};
